import gql from 'graphql-tag';

export const RIDE_COST_PER_SEAT_QUERY = gql`
  query getRideCostPerSeat($input: GetRideCostInput!) {
    getRideCostPerSeat(getRideCostInput: $input)
  }
`;
